import { render, staticRenderFns } from "./WeeklyWorkPohang.vue?vue&type=template&id=63c51527&scoped=true"
import script from "./WeeklyWorkPohang.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkPohang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c51527",
  null
  
)

export default component.exports